module.exports = __webpack_public_path__ + "img/10-1.5e0d42bc.png";